<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="申请开票"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>
		<div style="height: 46px;"></div>
		<div class='company_list_box' v-if="showList">
			<div v-for="item in list">
				<div class='company_list ui-flex' @click="add(item)">
					<div class='ui-flex-1'>
					    <div class='company_name'>{{item.companyName}}</div>
					    <div class='company_info'>经营者姓名：{{item.farenName}}</div>
					</div>
					<div class='billing_btn'>开票<van-icon name="arrow" /></div>
				</div>
			</div>
		</div>
		<van-empty v-else description="暂无可开票的个体户" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list : [],
				showList : true
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.$toast.loading({
					message: '请求中...',
					forbidClick: true,
					duration : 0
				});
				this.$get("/gtb/invoice/company.html",{ type : 1}).then(res => {
					this.$toast.clear();
					if( res.success ){
						var list = res.listYqbHandleCustomerCompanyPOs;
						this.list =list;
						this.showList = list.length > 0;
					}
				}).catch(error=>{
					this.$toast.clear();
				});
			},
			add(v){
				this.$router.push('/invoice/add?id=' + v.id + '&name=' + v.companyName);
			}
		},
	};
</script>

<style scoped>
	.company_list_box{ padding: 16px;}
	.company_list{padding:16px;background: #fff; border-radius: 9px; margin-bottom: 10px; }
	.company_name{ font-weight: bold;}
	.company_info{ color: #888;font-size: 14px; padding-top: 5px; }
	.billing_btn{ color: #2f86f6; display:flex;align-items: center;margin-left: 10px; }
</style>
